var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Tooltip } from 'ant-design-vue';
import { Component, Inject, Prop, Vue } from 'vue-property-decorator';
import { arrayify } from "../../../../../lib/utils/array";
let StyleItemWrapper = class StyleItemWrapper extends Vue {
  get helpTextRendered() {
    const h = this.$createElement;
    const content = this.$slots.desc || this.desc;
    if (!content) return null;
    return h(Tooltip, [h("div", {
      "slot": "title"
    }, [content]), h("a-icon", {
      "attrs": {
        "type": "info-circle"
      }
    })]);
  }
  get clearButtonRendered() {
    const h = this.$createElement;
    const resetableKeys = arrayify(this.propKey).filter(key => {
      var _this$stylePanel$styl;
      return (_this$stylePanel$styl = this.stylePanel.style) === null || _this$stylePanel$styl === void 0 ? void 0 : _this$stylePanel$styl[key];
    });
    const isDisabled = !resetableKeys.length;
    const reset = ev => {
      ev.preventDefault();
      resetableKeys.forEach(key => {
        this.$delete(this.stylePanel.style, key);
      });
    };
    return h("button", {
      "attrs": {
        "disabled": isDisabled
      },
      "on": {
        "click": reset
      },
      "class": "ucd-stylePanel-resetButton"
    }, [h("i", {
      "class": "fa fa-undo",
      "attrs": {
        "aria-hidden": "true"
      },
      "style": "margin-right: 4px"
    }), "\u91CD\u7F6E"]);
  }
  render() {
    const h = arguments[0];
    return h(Tooltip, {
      "attrs": {
        "placement": "topRight"
      }
    }, [h("div", {
      "slot": "title",
      "style": "display: flex; gap: 4px"
    }, [h("div", [this.title]), this.helpTextRendered, h("div", {
      "class": "flex: 1"
    }), this.clearButtonRendered]), h("div", {
      "class": "ucd-stylePanel-styleItemWrapper"
    }, [this.$slots.default])]);
  }
};
__decorate([Prop({
  type: String
})], StyleItemWrapper.prototype, "title", void 0);
__decorate([Prop({
  type: [String, Array]
})], StyleItemWrapper.prototype, "propKey", void 0);
__decorate([Prop({
  type: String,
  required: false
})], StyleItemWrapper.prototype, "desc", void 0);
__decorate([Inject()], StyleItemWrapper.prototype, "stylePanel", void 0);
StyleItemWrapper = __decorate([Component({})], StyleItemWrapper);
export { StyleItemWrapper };
//# sourceMappingURL=StyleItemWrapper.js.map
